export const atendimentoModel = {
    atendimento: function () {
      return {
        id: '',
        dt_atendimento: '',
        dt_proxatendimento: '',
        ds_observacao: '',
        processo_id: '',
      }
    },
  }


// WEBPACK FOOTER //
// ./src/models/atendimento.js